export const news =[
    {
      "source": {
        "id": null,
        "name": "Autocarpro.in"
      },
      "author": "Autocar Pro News Desk",
      "title": "New Ather e-scooter could be announced on January 7 - Autocar Professional",
      "description": "The new scooter could either be a more comfortable product or an all-new affordable one.",
      "url": "https://www.autocarpro.in/news/new-ather-e-scooter-could-be-announced-on-january-7-113703",
      "urlToImage": "https://cdni.autocarindia.com/utils/imageresizer.ashx?n=http://img.haymarketsac.in/autocarpro/98364c8c-2927-42c0-bdeb-2b88f46996b9_20221229023515_Ather-new-model.jpg",
      "publishedAt": "2022-12-30T13:18:03Z",
      "content": "The new scooter could either be a more comfortable product or an all-new affordable one.Ather Energy is holding its community day on January 7, 2023 and it might just showcase a new product there. Wh… [+1152 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "NDTV News"
      },
      "author": null,
      "title": "Centre Raises Interest Rates On Post Office Deposits, No Change In Provident Fund Rates - NDTV Profit",
      "description": "This is the second quarter of an increase in a row in interest rates for some schemes. This follows a status quo or unchanged rates for nine straight quarters.",
      "url": "https://www.ndtv.com/business/centre-raises-interest-rates-on-post-office-deposits-no-change-in-provident-fund-rates-3651220",
      "urlToImage": "https://c.ndtvimg.com/2022-12/v4fhghj_government-interest-rates_625x300_30_December_22.jpg?im=FaceCrop,algorithm=dnn,width=1200,height=675?ver-20221221.02",
      "publishedAt": "2022-12-30T13:15:00Z",
      "content": "Interest rates for small savings schemes are notified on a quarterly basis.(File)\r\nNew Delhi: The government today raised interest rates on most post office savings schemes that do not get income tax… [+2321 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Moneycontrol"
      },
      "author": "Moneycontrol News",
      "title": "Hate is public, love is private: Byju Raveendran to employees on his 2022 learnings - Moneycontrol",
      "description": "Byju Raveendran's comments on how users like Byju's courses come at a time when the company has been heavily criticised in the media about allegedly mis-selling and over-selling its courses, even to poor families in the country.",
      "url": "https://www.moneycontrol.com/news/business/startup/hate-is-public-love-is-private-byju-raveendran-to-employees-on-his-2022-learnings-9788911.html",
      "urlToImage": "https://images.moneycontrol.com/static-mcnews/2021/07/Byju-Raveendran-770x433.jpg",
      "publishedAt": "2022-12-30T13:00:49Z",
      "content": "Byju's remains undaunted by the 'negativity' going around about the edtech titan as the company and its management know the 'actual truth,' Byju Raveendran, founder and CEO, wrote to employees in an … [+3869 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Moneycontrol"
      },
      "author": "Rakesh Patil",
      "title": "Closing Bell: Nifty ends around 18,100, Sensex falls 293 points; PSU banks outperform - Moneycontrol",
      "description": "Among sectors, metal, realty and PSU Bank indices up 0.5-1 percent, while power, bank and FMCG indices down 0.5 percent each.",
      "url": "https://www.moneycontrol.com/news/business/markets/share-market-live-updates-stock-market-today-december-30-latest-news-bse-nse-sensex-nifty-covid-coronavirus-eicher-motors-poonawalla-fincorp-elin-electronics-kfin-technologies-ndtv-welspun-india-9784771.html",
      "urlToImage": "https://images.moneycontrol.com/static-mcnews/2022/08/Nifty_sensex-1-770x433.jpg",
      "publishedAt": "2022-12-30T11:01:17Z",
      "content": "<li>Antique maintains buy call on Garden Reach, target Rs 619\r\n</li><li>Crude demand expected to drop further due to surge in covid: Mohammed Imran\r\n</li><li>At 3 PM, about 2169 shares have advanced,… [+4412 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Zoom"
      },
      "author": "Devanshe Pandey",
      "title": "TCS Salary Hike claim fake or real? Here's what we know - Times Now",
      "description": "TCS Salary Hike: Tata Consultancy Services, TCS salary hike of 20 per cent is NOT true as confirmed the TCS officials. The reports of TCS offering Christmas bonanza to employees with salary hike isn't true and TCS has not released any official statement regar…",
      "url": "https://www.timesnownews.com/jobs/happy-new-year-tcs-salary-hike-announced-for-70-employees-20-raise-expected-article-96617461",
      "urlToImage": "https://static.tnn.in/thumb/msid-96617461,imgsize-100,updatedat-1672396287125,width-1280,height-720,resizemode-75/96617461.jpg",
      "publishedAt": "2022-12-30T10:24:00Z",
      "content": "Layoffs in 2022: Byju's, Ola, Blinkit, 3 other Indian startups sacked a total of more than 11,000 employees this year"
    },
    {
      "source": {
        "id": null,
        "name": "Autocarindia.com"
      },
      "author": "Dinshaw Magol",
      "title": "Ola to launch all-new electric scooter, e-bikes by 2024 - Autocar India",
      "description": "The first new two-wheeler from Ola in 2023 will be an accessible, mass-market scooter.",
      "url": "https://www.autocarindia.com/bike-news/ola-to-launch-all-new-electric-scooter-e-bikes-by-2024-426788",
      "urlToImage": "https://cdni.autocarindia.com/ExtraImages/20221230031243_Ola future plans.jpg",
      "publishedAt": "2022-12-30T10:03:00Z",
      "content": "The first new two-wheeler from Ola in 2023 will be an accessible, mass-market scooter. Ola Electric has revealed that it plans to launch multiple electric bikes and scooters by 2024. Ola currently ha… [+1344 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Moneycontrol"
      },
      "author": "Moneycontrol News",
      "title": "Uday Kotak flags three risks for India in 2023 - Moneycontrol",
      "description": "The RBI's inflation forecast is 6.7 percent for FY23, which is slightly above its upper tolerance limit of 6 percent. Uday Kotak believes inflation is a key risk",
      "url": "https://www.moneycontrol.com/news/business/markets/uday-kotak-flags-three-risks-for-india-in-2023-9786941.html",
      "urlToImage": "https://images.moneycontrol.com/static-mcnews/2021/04/Uday-Kotak-770x433.jpg",
      "publishedAt": "2022-12-30T09:01:47Z",
      "content": "The year 2022 was a year of reckoning for the Indian economy and equity markets. High inflation and rising interest rates took center-stage as markets remained volatile. As we head into 2023, several… [+3111 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "NDTV News"
      },
      "author": null,
      "title": "'Wonder Woman' Actor Comments On Viral Restaurant Fight Video, Internet In Splits - NDTV",
      "description": "While the two-minute-long video was shared last week, the incident took place in 2021.",
      "url": "https://www.ndtv.com/feature/wonder-woman-actor-comments-on-viral-restaurant-fight-video-internet-in-splits-3650266",
      "urlToImage": "https://c.ndtvimg.com/2022-12/sei5thfo_wonder-woman-restaurant-brawl-650_625x300_30_December_22.jpg",
      "publishedAt": "2022-12-30T07:33:00Z",
      "content": "'Wonder Woman's actor Lynda Carter posted a video similar to the restaurant fight.\r\nActor Lynda Carter, who played 'Wonder Woman' in the 1970s CBS series, posted a hilarious tweet, reacting to a figh… [+1485 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Team-BHP"
      },
      "author": "Tushar Kelshikar",
      "title": "Tata's 50,000th EV delivered to Group Chairman N Chandrasekaran - Team-BHP",
      "description": "Last month, Tata Motors celebrated the rollout of the 50,000th electric vehicle from its Pune plant. The milestone vehicle, which happened to be a Nexon EV, has now been delivered to Tata Group Chairman N Chandrasekaran.",
      "url": "https://www.team-bhp.com/news/tatas-50000th-ev-delivered-group-chairman-n-chandrasekaran",
      "urlToImage": "https://www.team-bhp.com/sites/default/files/styles/large/public/nexon-ev-50000-2.jpg",
      "publishedAt": "2022-12-30T07:32:46Z",
      "content": "Last month, Tata Motors celebrated the rollout of the 50,000th electric vehicle from its Pune plant. The milestone vehicle, which happened to be a Nexon EV, has now been delivered to Tata Group Chair… [+680 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Livemint"
      },
      "author": "Livemint",
      "title": "IDBI Bank signs agreement to transfer IDBI MF business to LIC Mutual Fund | Mint - Mint",
      "description": "LIC completed the takeover of IDBI Bank, the sponsor of IDBI Mutual Fund, in January 2019. However, LIC has its own asset management company, LIC Mutual Fund",
      "url": "https://www.livemint.com/companies/news/idbi-bank-signs-agreement-to-transfer-idbi-mf-business-to-lic-mutual-fund-11672384019371.html",
      "urlToImage": "https://images.livemint.com/img/2022/12/30/600x338/INDIA-IDBI-BANK-2_1671000506978_1671000506978_1672385062687_1672385062687.jpg",
      "publishedAt": "2022-12-30T07:25:15Z",
      "content": "IDBI Bank signed an agreement on December 29 to transfer schemes from IDBI Mutual Fund (IDBI MF) to LIC Mutual Fund (LIC MF). In terms of Regulation 30 of the SEBI (LODR) Regulations, 2015, we hereby… [+1839 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Moneycontrol"
      },
      "author": "Moneycontrol News",
      "title": "Craftsman Automation shares on fire after buying out DR Axion India - Moneycontrol",
      "description": "",
      "url": "https://www.moneycontrol.com/news/business/markets/craftsman-automation-shares-on-fire-after-buying-out-dr-axion-india-9786721.html",
      "urlToImage": "https://images.moneycontrol.com/static-mcnews/2022/12/marketup_sensexup-Niftyup-2-770x433.jpg",
      "publishedAt": "2022-12-30T07:10:48Z",
      "content": "Shares of Craftsman Automation, an auto ancillary manufacturer, spiked 370 points or a little over 11 percent after it entered into a definitive agreement to acquire a 76 percent of DR Axion India. A… [+1716 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "YouTube"
      },
      "author": null,
      "title": "Toyota Innova Hycross Launched in India - Prices, Variants, vs Competition and vs Crysta | CarWale - CarWale",
      "description": "The Toyota Innova Hycross price in India has been announced. It Hycross' base model is priced at Rs 18.30 lakh, while the top-end model costs Rs 28.97 lakh, ...",
      "url": "https://www.youtube.com/watch?v=yDo9JaybIuM",
      "urlToImage": "https://i.ytimg.com/vi/yDo9JaybIuM/maxresdefault.jpg",
      "publishedAt": "2022-12-30T06:51:02Z",
      "content": null
    },
    {
      "source": {
        "id": null,
        "name": "CNBC"
      },
      "author": "Jihye Lee",
      "title": "Asia-Pacific markets rise in final trading session of 2022 - CNBC",
      "description": "Stocks in the Asia-Pacific are set to trade higher after Wall Street rebounded overnight, recovering most losses from the previous session.",
      "url": "https://www.cnbc.com/2022/12/30/asia-markets-south-korea-inflation.html",
      "urlToImage": "https://image.cnbcfm.com/api/v1/image/107172471-1672365838654-gettyimages-1245864022-HK_COVID.jpeg?v=1672365953&w=1920&h=1080",
      "publishedAt": "2022-12-30T06:47:00Z",
      "content": "Chinese markets will likely see a \"tactical bounce\" of a recovery in the coming year, Port Shelter Investment Management said.\r\n\"It's only obvious to say that we're likely to see a tactical bounce,\" … [+538 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Investing.com"
      },
      "author": "Geoffrey Smith/Investing.com",
      "title": "Inflation, China's COVID bounce, teetering crypto: what'll move markets in 2023 By Investing.com - Investing.com",
      "description": "Inflation, China's COVID bounce, teetering crypto: what'll move markets in 2023",
      "url": "https://www.investing.com/news/economy/inflation-chinas-covid-bounce-teetering-crypto-whatll-move-markets-in-2023-2968312",
      "urlToImage": "https://i-invdn-com.investing.com/news/WallStreet_800x533_L_1632377181.jpg",
      "publishedAt": "2022-12-30T06:42:00Z",
      "content": "By Geoffrey Smith\r\nInvesting.com -- First the good news: 2022, a nightmare year for both stocks and bonds, is nearly over. Now the bad news: while 2023 is likely to be better, it won’t really seem th… [+9063 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Greatandhra.com"
      },
      "author": "IANS",
      "title": "Worst months for layoffs arrive as thousands brace for job losses - Greatandhra",
      "description": "After a holiday lull, more layoffs are around the corner and several companies across the spectrum, led by tech firms, are set to layoff thousands of employees, starting January.",
      "url": "https://www.greatandhra.com/articles/special-articles/worst-months-for-layoffs-arrive-in-usa-126271",
      "urlToImage": "https://www.greatandhra.com/newphotos10/jobs11672380771.jpg",
      "publishedAt": "2022-12-30T06:12:51Z",
      "content": "San Francisco: After a holiday lull, more layoffs are around the corner and several companies across the spectrum, led by tech firms, are set to layoff thousands of employees, starting January.\r\nAcco… [+1893 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "CNBC"
      },
      "author": "Elliot Smith",
      "title": "European stocks set to log worst year since 2018 - CNBC",
      "description": "Economies around the world began the year still trying to emerge from the Covid-19 pandemic.",
      "url": "https://www.cnbc.com/2022/12/30/european-stocks-set-to-log-worst-year-since-2018.html",
      "urlToImage": "https://image.cnbcfm.com/api/v1/image/106927823-1629093349097-gettyimages-1234649992-20090101210813-99-828960.jpeg?v=1672380691&w=1920&h=1080",
      "publishedAt": "2022-12-30T06:10:27Z",
      "content": "LONDON European markets are on course for their worst year since 2018 as Russia's war in Ukraine, high inflation and tightening monetary policy hammered risk assets around the world.\r\nThe pan-Europea… [+1867 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Moneycontrol"
      },
      "author": "Moneycontrol News",
      "title": "Pune man ordered food worth over Rs 28 lakh on Zomato in 2022 - Moneycontrol",
      "description": "Zomato's year-end report has revealed some lavish spending by customers.",
      "url": "https://www.moneycontrol.com/news/trends/lifestyle-trends/zomato-2022-report-pune-man-ordered-food-worth-over-rs-28-lakh-9786031.html",
      "urlToImage": "https://images.moneycontrol.com/static-mcnews/2021/04/RTX7JWXD-770x433.jpg",
      "publishedAt": "2022-12-30T05:32:10Z",
      "content": "Spent big on ordering in this year? Certainly not as much as these Zomato customers.\r\nZomato's year-end report has revealed some lavish spending by customers, including one who ordered pizzas worth o… [+1569 chars]"
    },
    {
      "source": {
        "id": "the-times-of-india",
        "name": "The Times of India"
      },
      "author": "Gourab Das",
      "title": "Homebuyers must get tax benefits in Budget to make India's real estate take on the world, say stakeholders - Economic Times",
      "description": "The pent-up demand of the last two years and the strong need to own residential properties in the wake of the pandemic were among the major demand drivers behind the strong revival in the real estate sector.  For more impetus, real estate stakeholders now loo…",
      "url": "https://economictimes.indiatimes.com/industry/services/property-/-cstruction/homebuyers-must-get-tax-benefits-in-budget-to-make-indias-real-estate-take-on-the-world-say-stakeholders/articleshow/96612165.cms",
      "urlToImage": "https://img.etimg.com/thumb/msid-96613644,width-1070,height-580,imgsize-639971,overlay-economictimes/photo.jpg",
      "publishedAt": "2022-12-30T05:32:00Z",
      "content": "Indias policymakers and top government officials boast how the country has emerged as a strong growth story in comparison to challenges outside in the world. In fact, many overseas experts too have v… [+10738 chars]"
    },
    {
      "source": {
        "id": null,
        "name": "Moneycontrol"
      },
      "author": "Chandra R Srikanth",
      "title": "Leaders in IT will continue to be leaders for quite some time: Infosys co-founder Kris Gopalakrishnan - Moneycontrol",
      "description": "Rajiv Gandhi's focus on technology was very important for India's development, says Infosys co-founder Kris Gopalakrishnan",
      "url": "https://www.moneycontrol.com/news/business/leaders-in-it-will-continue-to-be-leaders-for-quite-some-time-infosys-co-founder-kris-gopalakrishnan-9786221.html",
      "urlToImage": "https://images.moneycontrol.com/static-mcnews/2022/12/kris_01-696x435.jpg",
      "publishedAt": "2022-12-30T05:23:27Z",
      "content": "The Indian IT industry has come a long way since the arrival of an IBM 1620 computer at IIT Kanpur in 1963, carried by a bullock cart. It has now reached a total revenue of over $200 billion and a to… [+9081 chars]"
    },
    {
      "source": {
        "id": "al-jazeera-english",
        "name": "Al Jazeera English"
      },
      "author": "Al Jazeera",
      "title": "Indonesia to tighten palm oil exports from January 1 - Al Jazeera English",
      "description": "Exporters will be allowed to ship six times their domestic sales volume, less than the current ratio of eight times.",
      "url": "https://www.aljazeera.com/economy/2022/12/30/indonesia-to-tighten-palm-oil-exports-from-january-1",
      "urlToImage": "https://www.aljazeera.com/wp-content/uploads/2019/08/c775f21296c24054a5431ee7f812957b_18.jpeg?resize=1200%2C675",
      "publishedAt": "2022-12-30T05:15:00Z",
      "content": "Indonesia will tighten export rules for palm oil from January 1 by allowing fewer shipments overseas for every tonne sold domestically, in a move aimed at ensuring sufficient domestic supply.\r\nExport… [+1690 chars]"
    },
    {
        "source": {
          "id": null,
          "name": "Yahoo Entertainment"
        },
        "author": "Robert Brand and Stephen Kirkland",
        "title": "US Stocks Drop With Bonds as Brutal Year Nears End: Markets Wrap - Yahoo Finance",
        "description": "(Bloomberg) -- US stocks declined on the final trading day of 2022 as financial markets close out the worst year in more than a decade for global equities...",
        "url": "https://finance.yahoo.com/news/asia-stocks-rise-p-500-233248167.html",
        "urlToImage": "https://s.yimg.com/ny/api/res/1.2/Vgrt.ZTT0oyTKJ7deVaQFA--/YXBwaWQ9aGlnaGxhbmRlcjt3PTEyMDA7aD04MDA-/https://media.zenfs.com/en/bloomberg_markets_842/66eb684edb974176d2a840428be7b9e8",
        "publishedAt": "2022-12-30T14:31:22Z",
        "content": "(Bloomberg) -- US stocks declined on the final trading day of 2022 as financial markets close out the worst year in more than a decade for global equities and bonds.\r\nMost Read from Bloomberg\r\nThe S&… [+3422 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "CNBC"
        },
        "author": "Ryan Browne",
        "title": "Bahamian regulator says it seized $3.5 billion of FTX crypto assets for 'safekeeping' - CNBC",
        "description": "The Securities Commission of The Bahamas said it moved $3.5 billion from FTX's Bahamian subsidiary, FTX Digital Markets, into its own digital wallets.",
        "url": "https://www.cnbc.com/2022/12/30/bahamas-regulator-seized-3point5-billion-of-ftx-crypto-assets.html",
        "urlToImage": "https://image.cnbcfm.com/api/v1/image/107172502-1672395351694-gettyimages-1245052550-FTX_ILLO.jpeg?v=1672404741&w=1920&h=1080",
        "publishedAt": "2022-12-30T12:52:21Z",
        "content": "The Securities Commission of The Bahamas says it seized $3.5 billion worth of cryptocurrency from collapsed crypto exchange FTX.\r\nIn a media release late Thursday, the watchdog confirmed the total su… [+2251 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "CNBC"
        },
        "author": "Peter Schacknow",
        "title": "Stocks making the biggest moves premarket: Shaw Communications, Li Auto, Southwest and others - CNBC",
        "description": "These are the stocks posting the largest moves before the bell.",
        "url": "https://www.cnbc.com/2022/12/30/stocks-making-the-biggest-moves-premarket-shaw-communications-li-auto-southwest-and-others.html",
        "urlToImage": "https://image.cnbcfm.com/api/v1/image/106841126-16135104622021-02-16t204145z_1290440652_rc2wtl9euyvu_rtrmadp_0_usa-stocks.jpeg?v=1672404514&w=1920&h=1080",
        "publishedAt": "2022-12-30T12:48:34Z",
        "content": "Check out the companies making headlines before the bell:\r\nShaw Communications (SJR) Canada's Competition Tribunal dismissed an attempt by the country's competition watchdog to block the $26 billion … [+1465 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "CNBC"
        },
        "author": "Jesse Pound, Samantha Subin",
        "title": "Stock futures edge lower as Wall Street awaits final trading day of 2022 - CNBC",
        "description": "Stocks are on pace to snap a three-year win streak and finish their worst year since 2008.",
        "url": "https://www.cnbc.com/2022/12/29/stock-market-futures-open-to-close-news.html",
        "urlToImage": "https://image.cnbcfm.com/api/v1/image/107172157-1672320963293-trad.jpg?v=1672380744&w=1920&h=1080",
        "publishedAt": "2022-12-30T12:43:00Z",
        "content": "Stock futures edged lower in premarket trading Friday as investors braced for the final trading day of the worst year for stocks since 2008.\r\nFutures tied to the Dow Jones Industrial Average slipped … [+2877 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "BBC News"
        },
        "author": "https://www.facebook.com/bbcnews",
        "title": "Hershey sued in US over metal in dark chocolate claim - BBC",
        "description": "The lawsuit alleges that three Hershey products contain harmful levels of lead and cadmium.",
        "url": "https://www.bbc.com/news/business-64123157",
        "urlToImage": "https://ichef.bbci.co.uk/news/1024/branded_news/4DDF/production/_128153991_7ad82c3ef6b27b0d6ff8d7880758d76ffd47936c.jpg",
        "publishedAt": "2022-12-30T10:30:37Z",
        "content": "Chocolate manufacturer Hershey has been sued in the US over claims the firm is selling products containing harmful levels of metal.\r\nThe lawsuit brought by Christopher Lazazzaro alleges the firm misl… [+2322 chars]"
      },
      {
        "source": {
          "id": "the-wall-street-journal",
          "name": "The Wall Street Journal"
        },
        "author": "Meghan Bobrowsky",
        "title": "Tesla Stock Is Headed for Its Biggest-Ever Annual Decline - The Wall Street Journal",
        "description": "Elon Musk’s electric-vehicle maker has shed more than $700 billion in market valuation in 2022",
        "url": "https://www.wsj.com/articles/tesla-stock-is-headed-for-its-biggest-ever-annual-decline-11672374248",
        "urlToImage": "https://images.wsj.net/im-694429/social",
        "publishedAt": "2022-12-30T10:30:00Z",
        "content": "Tesla Inc. is poised Friday to close the worst year in the stocks history, having lost more than $700 billion in market valuation amid investor concerns about production disruptions, demand worries a… [+475 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "CoinDesk"
        },
        "author": "Sam Reynolds",
        "title": "Cathie Wood Continues Buying Coinbase's Dip With $5 Million Stock Purchase - CoinDesk",
        "description": "ARK's Fintech Innovation ETF adds 158,000 shares of COIN to its holdings as stock hits an all-time low.",
        "url": "https://www.coindesk.com/markets/2022/12/30/cathie-wood-continues-buying-coinbases-dip-with-5-million-stock-purchase/",
        "urlToImage": "https://www.coindesk.com/resizer/CcA1hPj9CixDMmECfevrIgsJOTI=/1200x628/center/middle/cloudfront-us-east-1.images.arcpublishing.com/coindesk/PJEKYB4DLNGJ5AHLUZ3ZPYG5JI.jpg",
        "publishedAt": "2022-12-30T10:01:00Z",
        "content": "ARK Invest, a technology and fintech firm run by Cathie Wood, made its largest investment in Coinbase (COIN) stock since Dec. 14 on Thursday, adding about $5.5 million of the shares, based on closing… [+1510 chars]"
      },
      {
        "source": {
          "id": "cnn",
          "name": "CNN"
        },
        "author": "Tami Luhby",
        "title": "Senior citizens will soon get that big hike in their Social Security benefits - CNN",
        "description": "Senior citizens and other Social Security recipients will start getting a heftier monthly benefit next month due to an 8.7% annual cost-of-living adjustment aimed at helping them cope with high inflation.",
        "url": "https://www.cnn.com/2022/12/30/politics/social-security-cola-2023-increase/index.html",
        "urlToImage": "https://media.cnn.com/api/v1/images/stellar/prod/221020122201-social-security-card-file.jpg?c=16x9&q=w_800,c_fill",
        "publishedAt": "2022-12-30T10:00:00Z",
        "content": "Senior citizens and other Social Security recipients will start getting a heftier monthly benefit next month due to an 8.7% annual cost-of-living adjustment aimed at helping them cope with high infla… [+4406 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "TheStreet"
        },
        "author": "Luc Olinga",
        "title": "MicroStrategy Sells Bitcoin For the First Time - TheStreet",
        "description": "The enterprise-software specialist is known to be the largest company holding bitcoins.",
        "url": "https://www.thestreet.com/investing/cryptocurrency/microstrategy-sells-bitcoin-for-the-first-time",
        "urlToImage": "https://www.thestreet.com/.image/t_share/MTg3MTEzOTc4NTUwNDI4ODEz/michael-saylor-1.jpg",
        "publishedAt": "2022-12-30T09:06:08Z",
        "content": "It's a big surprise.\r\nMicroStrategy, the company of Michael Saylor, one of the most fervent evangelists of Bitcoin, has sold the king of cryptocurrencies.\r\nThe move was made recently, according to a … [+3249 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Fox Business"
        },
        "author": "Ken Martin",
        "title": "Huawei stabilizes as sanctions impact wanes - Fox Business",
        "description": "Huawei says its sales decline is leveling off following the imposing of sanctions on the company by the U.S.",
        "url": "https://www.foxbusiness.com/technology/huawei-stabilizes-sanctions-impact-wanes",
        "urlToImage": "https://a57.foxnews.com/static.foxbusiness.com/foxbusiness.com/content/uploads/2021/10/0/0/Huawei-profits-fall-2.jpg?ve=1&tl=1",
        "publishedAt": "2022-12-30T08:25:06Z",
        "content": "Business at Chinese tech giant Huawei Technologies has reached a new normal as the sales decline following the imposition of U.S. sanctions leveling off.\r\nThe company estimated on Friday that its 202… [+1305 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "CNBC"
        },
        "author": "Jihye Lee",
        "title": "Asia-Pacific markets rise in final trading session of 2022 - CNBC",
        "description": "Stocks in the Asia-Pacific are set to trade higher after Wall Street rebounded overnight, recovering most losses from the previous session.",
        "url": "https://www.cnbc.com/2022/12/30/asia-markets-south-korea-inflation.html",
        "urlToImage": "https://image.cnbcfm.com/api/v1/image/107172471-1672365838654-gettyimages-1245864022-HK_COVID.jpeg?v=1672365953&w=1920&h=1080",
        "publishedAt": "2022-12-30T06:47:00Z",
        "content": "Chinese markets will likely see a \"tactical bounce\" of a recovery in the coming year, Port Shelter Investment Management said.\r\n\"It's only obvious to say that we're likely to see a tactical bounce,\" … [+538 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "CNBC"
        },
        "author": "Elliot Smith",
        "title": "European stocks set to log worst year since 2018 - CNBC",
        "description": "Economies around the world began the year still trying to emerge from the Covid-19 pandemic.",
        "url": "https://www.cnbc.com/2022/12/30/european-stocks-set-to-log-worst-year-since-2018.html",
        "urlToImage": "https://image.cnbcfm.com/api/v1/image/106927823-1629093349097-gettyimages-1234649992-20090101210813-99-828960.jpeg?v=1672380691&w=1920&h=1080",
        "publishedAt": "2022-12-30T06:10:27Z",
        "content": "LONDON European markets are on course for their worst year since 2018 as Russia's war in Ukraine, high inflation and tightening monetary policy hammered risk assets around the world.\r\nThe pan-Europea… [+1867 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Fox Business"
        },
        "author": "Ken Martin",
        "title": "Oil set to end turbulent 2022 higher - Fox Business",
        "description": "U.S. West Intermediate crude is heading toward posting a second straight annual gain, rising 4.5% in 2022.",
        "url": "https://www.foxbusiness.com/markets/oil-set-end-turbulent-2022-higher",
        "urlToImage": "https://a57.foxnews.com/static.foxbusiness.com/foxbusiness.com/content/uploads/2022/06/0/0/f812147a-Oil-1-iStock-blog.jpg?ve=1&tl=1",
        "publishedAt": "2022-12-30T05:54:59Z",
        "content": "Oil prices traded higher on Friday and were on track to post their second straight annual gains.\r\nOil had a stormy year marked by tight supplies due to the Ukraine war, a strong dollar and weakening … [+1731 chars]"
      },
      {
        "source": {
          "id": "financial-times",
          "name": "Financial Times"
        },
        "author": "Richard Waters",
        "title": "Musk breaks the spell he had woven around Tesla - Financial Times",
        "description": "As auto industry faces an uncertain 2023, entrepreneur must take some of the blame for company’s problems",
        "url": "https://www.ft.com/content/cf81ea51-d1bb-4145-8157-e514025c63ef",
        "urlToImage": "https://www.ft.com/__origami/service/image/v2/images/raw/https%3A%2F%2Fd1e00ek4ebabms.cloudfront.net%2Fproduction%2F9df742c1-785e-4a0e-a2f7-2188312f964c.jpg?source=next-opengraph&fit=scale-down&width=900",
        "publishedAt": "2022-12-30T05:00:06Z",
        "content": "For much of this year, as other growth stocks collapsed, Tesla appeared to defy gravity. The bulls complained that shares in Elon Musks electric carmaker were suffering because of his offer for Twitt… [+4117 chars]"
      },
      {
        "source": {
          "id": "bloomberg",
          "name": "Bloomberg"
        },
        "author": "Jan-Patrick Barnert",
        "title": "Stock Market 2023: After $18 Trillion Rout, Equity Faces More Hurdles Next Year - Bloomberg",
        "description": "More tech tantrums. China’s Covid surge. And above all, no central banks riding to the rescue if things go wrong. Reeling from a record $18 trillion wipeout, global stocks must surmount all these hurdles and more if they are to escape a second straight year i…",
        "url": "https://www.bloomberg.com/news/articles/2022-12-30/after-18-trillion-rout-global-stocks-face-more-hurdles-in-2023",
        "urlToImage": "https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iQWc1jSAYHaQ/v0/1200x800.jpg",
        "publishedAt": "2022-12-30T05:00:00Z",
        "content": "More tech tantrums. China’s Covid surge. And above all, no central banks riding to the rescue if things go wrong. Reeling from a record $18 trillion wipeout, global stocks must surmount all these hur… [+343 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "YouTube"
        },
        "author": null,
        "title": "Southwest Airlines: Medical procedure canceled for Austin teen after doctor can't fly home - KXAN",
        "description": "You’ve heard the stories about lost luggage and people having to take road trips across the country because of Southwest Airlines cancellations, but some peo...",
        "url": "https://www.youtube.com/watch?v=zKI21tXBLeE",
        "urlToImage": "https://i.ytimg.com/vi/zKI21tXBLeE/maxresdefault.jpg",
        "publishedAt": "2022-12-30T04:27:48Z",
        "content": null
      },
      {
        "source": {
          "id": null,
          "name": "Benzinga"
        },
        "author": "Bhavik Nair",
        "title": "Cathie Wood Loads Up On Tesla Shares For Third Straight Day: Also Makes Over $5M Purchase In This Crypto-Related Stock - Tesla (NASDAQ:TSLA), Coinbase Global (NASDAQ:COIN) - Benzinga",
        "description": "As Tesla shares continued to rally for the second day, Cathie Wood-led ARK Investment Management bought 22,514 shares of the EV-maker at an estimated valuation of over $2.74 million.",
        "url": "https://www.benzinga.com/markets/cryptocurrency/22/12/30233249/cathie-wood-loads-up-on-tesla-shares-for-third-straight-day-also-makes-over-5m-purchase-in",
        "urlToImage": "https://cdn.benzinga.com/files/images/story/2022/12/29/vlad-tchompalov-jwyo3nhpzkq-unsplash.jpg?width=1200&height=800&fit=crop",
        "publishedAt": "2022-12-30T02:39:14Z",
        "content": "As Tesla shares continued to rally for the second day, Cathie Wood-led ARK Investment Management bought 22,514 shares of the EV-maker at an estimated valuation of over $2.74 million.\r\nWhat Happened: … [+1387 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "YouTube"
        },
        "author": null,
        "title": "Southwest Airlines says they expect to return to normal operations - ABC News",
        "description": null,
        "url": "https://www.youtube.com/supported_browsers?next_url=https:%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D8wHGMyyN9TE",
        "urlToImage": null,
        "publishedAt": "2022-12-30T01:30:15Z",
        "content": null
      },
      {
        "source": {
          "id": null,
          "name": "OPB News"
        },
        "author": "April Ehrlich",
        "title": "PGE, Pacific Power electricity rates increase Jan. 1 - Oregon Public Broadcasting",
        "description": "Oregon’s utility regulator on Thursday announced approved rate increases for Portland General Electric and Pacific Power customers, citing increased costs to produce and purchase electricity.",
        "url": "https://www.opb.org/article/2022/12/29/portland-general-electric-pacific-powe-electricity-rates-increase-jan-1-pge/",
        "urlToImage": "https://opb-opb-prod.cdn.arcpublishing.com/resizer/tipl2rKQVZeE3DYIvuRNfs80mEc=/1200x675/smart/cloudfront-us-east-1.images.arcpublishing.com/opb/XLHO4LUNQ5AXTFY66FEIHPEPKU.jpg",
        "publishedAt": "2022-12-30T00:56:33Z",
        "content": "Portland General Electric's Beaver Power Plant has been in operation since 1974.\r\nCourtesy of PGE\r\nMany Oregonians can expect higher electricity bills starting on New Years Day.\r\nOregons utility regu… [+1739 chars]"
      },
      {
        "source": {
          "id": "reuters",
          "name": "Reuters"
        },
        "author": null,
        "title": "TSMC starts volume production of most advanced chips in Taiwan - Reuters",
        "description": "Chipmaker Taiwan Semiconductor Manufacturing Company Ltd (TSMC)<a href=\"https://www.reuters.com/companies/2330.TW\" target=\"_blank\">(2330.TW)</a>, began mass production of its most advanced chips in southern Taiwan on Thursday and the company's chairman said i…",
        "url": "https://www.reuters.com/technology/tsmc-starts-volume-production-most-advanced-chips-taiwan-2022-12-29/",
        "urlToImage": "https://www.reuters.com/resizer/V6Ks5QNOxMSYKqtbbUOyz4MeVts=/1200x628/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/BWXBGLLI2FJEXA7NLEL2BPEZME.jpg",
        "publishedAt": "2022-12-29T23:58:00Z",
        "content": "TAINAN, Taiwan, Dec 29 (Reuters) - Chipmaker Taiwan Semiconductor Manufacturing Company Ltd (TSMC)(2330.TW), began mass production of its most advanced chips in southern Taiwan on Thursday and the co… [+2242 chars]"
      },
      {
        "source": {
          "id": "the-washington-post",
          "name": "The Washington Post"
        },
        "author": "Blaine P. Friedlander Jr.",
        "title": "Skywatch: Shooting stars, a planetary conjunction and brighter days - The Washington Post",
        "description": "A description of planetary activity in January.",
        "url": "https://www.washingtonpost.com/science/2022/12/30/skywatch-shooting-stars-planetary-conjunction-brighter-days/",
        "urlToImage": "https://www.washingtonpost.com/resizer/2CjPNwqvXHPS_2RpuRTKY-p3eVo=/1484x0/www.washingtonpost.com/pb/resources/img/twp-social-share.png",
        "publishedAt": "2022-12-30T16:15:24Z",
        "content": "Comment on this story\r\nThe new year starts with Mars and the moon in revelry, shooting stars in early January, and the planetary duo of Venus and Saturn preparing for a late-month conjunction. Oh and… [+3762 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Phys.Org"
        },
        "author": "Rod Boyce",
        "title": "NASA and HAARP conclude asteroid experiment - Phys.org",
        "description": "A powerful transmitter in remote Alaska sent long wavelength radio signals into space Tuesday with the purpose of bouncing them off an asteroid to learn about its interior.",
        "url": "https://phys.org/news/2022-12-nasa-haarp-asteroid.html",
        "urlToImage": "https://scx2.b-cdn.net/gfx/news/2022/nasa-and-haarp-conclud-1.jpg",
        "publishedAt": "2022-12-30T16:09:04Z",
        "content": "A powerful transmitter in remote Alaska sent long wavelength radio signals into space Tuesday with the purpose of bouncing them off an asteroid to learn about its interior.\r\nThe asteroid, 2010 XC15, … [+4077 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Phys.Org"
        },
        "author": "Tomasz Nowakowski",
        "title": "Chinese astronomers detect over 100 new open clusters - Phys.org",
        "description": "By analyzing the data from ESA's Gaia satellite, astronomers from the Shanghai Astronomical Observatory (SHAO) in China have detected 101 new open clusters in the Milky Way galaxy. The discovery was presented in a paper published December 21 on the arXiv pre-…",
        "url": "https://phys.org/news/2022-12-chinese-astronomers-clusters.html",
        "urlToImage": "https://scx2.b-cdn.net/gfx/news/hires/2022/chinese-astronomers-de.jpg",
        "publishedAt": "2022-12-30T15:11:26Z",
        "content": "By analyzing the data from ESA's Gaia satellite, astronomers from the Shanghai Astronomical Observatory (SHAO) in China have detected 101 new open clusters in the Milky Way galaxy. The discovery was … [+3275 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Phys.Org"
        },
        "author": "Brian Koberlein",
        "title": "New measurements of galaxy rotation lean toward modified gravity as an explanation for dark matter - Phys.org",
        "description": "Although dark matter is a central part of the standard cosmological model, it's not without its issues. There continue to be nagging mysteries about the stuff, not the least of which is the fact that scientists have found no direct particle evidence of it.",
        "url": "https://phys.org/news/2022-12-galaxy-rotation-gravity-explanation-dark.html",
        "urlToImage": "https://scx2.b-cdn.net/gfx/news/2022/new-measurements-of-ga.jpg",
        "publishedAt": "2022-12-30T15:07:26Z",
        "content": "Although dark matter is a central part of the standard cosmological model, it's not without its issues. There continue to be nagging mysteries about the stuff, not the least of which is the fact that… [+3513 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Hot Hardware"
        },
        "author": "Tim Sweezy",
        "title": "NASA Seeks Private Sector Help To Extend Hubble's Life Span For Deep Space Exploration - Hot Hardware",
        "description": "NASA is seeking help from the private sector to re-boost the Hubble Space Telescope at no cost to the government.",
        "url": "https://hothardware.com/news/nasa-seeks-private-sector-help-to-extend-hubbles-life-span-for-deep-space-exploration",
        "urlToImage": "https://images.hothardware.com/contentimages/newsitem/60511/content/hubble-galaxies.jpg",
        "publishedAt": "2022-12-30T14:26:00Z",
        "content": "NASA is seeking interest and ideas in developing capabilities to re-boost the orbit of a satellite. The space agency is considering utilizing the Hubble Space Telescope for a demonstration in the nex… [+2797 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Futurity: Research News"
        },
        "author": "Daniel Stolte-Arizona",
        "title": "Probe Could Find Whether Saturn's Moon Hosts Life - Nextgov",
        "description": "A future mission to Enceladus, one of Saturn's 83 moons, could discover its potential for harboring alien life—all without ever landing.",
        "url": "https://www.futurity.org/enceladus-alien-life-2848262-2/",
        "urlToImage": "https://www.futurity.org/wp/wp-content/uploads/2022/12/Enceladus-alien-life-saturn-moon-1600.jpg",
        "publishedAt": "2022-12-30T14:23:37Z",
        "content": "The mystery of whether microbial alien life might inhabit Enceladus, one of Saturn’s 83 moons, could be solved by an orbiting space probe, according to a new study.\r\nIn a new paper in the Planetary S… [+7187 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Tvpworld.com"
        },
        "author": "Telewizja Polska S.A",
        "title": "SpaceX's final flight of 2022 deploys Israeli satellite to orbit - TVP World",
        "description": "The satellite, EROS C-3 is equipped with redundant camera systems capable of resolving surface features less than one foot across.",
        "url": "https://www.tvpworld.com/65380668/spacexs-final-flight-of-2022-deploys-israeli-satellite-to-orbit",
        "urlToImage": "http://s7.tvp.pl/images2/7/0/b/uid_70b8e98053297f45c99e228ca53c094a1672405111502_width_960_play_0_pos_0_gs_0_height_540.jpg",
        "publishedAt": "2022-12-30T13:14:09Z",
        "content": "SpaceX launched the final rocket of 2022 into space on Friday. The company sent a Falcon 9 rocket with an Israeli Earth-imaging satellite to Earths orbit. It was the California rocket builders 61st l… [+1208 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Devdiscourse"
        },
        "author": "Devdiscourse News Desk",
        "title": "Science News Roundup: South Korea's test flight of solid-propellant space launch vehicle successful - ministry; NASA mulls SpaceX backup plan for crew of Russia's leaky Soyuz ship - Devdiscourse",
        "description": "Earlier on Friday, South Korean media reported multiple citings of an unidentified flying object over the country's airspace.  NASA mulls SpaceX backup plan for crew of Russia's leaky Soyuz ship  NASA is exploring whether SpaceX's Crew Dragon spacecraft can p…",
        "url": "https://www.devdiscourse.com/article/technology/2303720-science-news-roundup-south-koreas-test-flight-of-solid-propellant-space-launch-vehicle-successful---ministry-nasa-mulls-sp",
        "urlToImage": "https://www.devdiscourse.com/remote.axd?https://devdiscourse.blob.core.windows.net/devnews/10_06_2022_10_02_51_124674.webp?width=920&format=jpeg",
        "publishedAt": "2022-12-30T13:00:55Z",
        "content": "Following is a summary of current science news briefs.\r\nSouth Korea's test flight of solid-propellant space launch vehicle successful - ministry\r\nSouth Korea conducted a successful test flight of a s… [+813 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "The Weather Channel"
        },
        "author": "The Weather Channel",
        "title": "Study Finds First Ever Instance of An Organism Feeding On a Virus | Weather.com - The Weather Channel",
        "description": "Viruses can make for great snacks for other microbes because they are rich in nucleic acids, meaning they contain a lot of nitrogen and phosphorous.",
        "url": "https://weather.com/en-IN/india/science/news/2022-12-30-study-finds-first-ever-instance-of-an-organism-feeding-on-a-virus",
        "urlToImage": "https://s.w-x.co/in-chlorovirus.jpg",
        "publishedAt": "2022-12-30T12:48:27Z",
        "content": "Our ecosystems are made up of herbivores, carnivores and omnivores, all tangled up in a convoluted and intricate web that somehow works. But if you think food webs among macroorganisms like plants an… [+2519 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Insightsonindia.com"
        },
        "author": "Insights Editor",
        "title": "The Webb telescope is just getting started - INSIGHTSIAS - Insights IAS",
        "description": "GS Paper 3 Syllabus: Space Technology Source: Indian Express   Context: It was launched one year ago on a mission to observe the universe in wavelengths no human eye can see. With a primary mirror 21 feet wide, the Webb is seven times as powerful as the Hubbl…",
        "url": "https://www.insightsonindia.com/2022/12/30/the-webb-telescope-is-just-getting-started/",
        "urlToImage": "https://www.insightsonindia.com/wp-content/uploads/2022/12/james_web-1024x490.jpg",
        "publishedAt": "2022-12-30T11:51:44Z",
        "content": null
      },
      {
        "source": {
          "id": "business-insider",
          "name": "Business Insider"
        },
        "author": "Paola Rosa-Aquino",
        "title": "What the Voyager probes should see next: Oort Cloud, other stars - Business Insider",
        "description": "Voyager 1 crossed the heliopause in 2012 and is drifting through interstellar space at the edge of our Milky Way galaxy, which has a lot of nothing.",
        "url": "https://www.businessinsider.com/what-will-voyager-1-2-probes-see-next-nasa",
        "urlToImage": "https://i.insider.com/63adaef73e42ed001855d05a?width=1200&format=jpeg",
        "publishedAt": "2022-12-30T11:14:00Z",
        "content": "Some 14.8 billion miles from Earth, the Voyager 1 probe is cruising through the blackness of the interstellar medium the unexplored space between stars. It's the furthest human-made objects from our … [+3439 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Space.com"
        },
        "author": "Charles Q. Choi",
        "title": "This wild interstellar picogram probe idea could carry engineered microbes to other stars - Space.com",
        "description": "The microbes could build equipment once they landed on a planet, according to the wild concept.",
        "url": "https://www.space.com/interstellar-probes-microbes-other-stars",
        "urlToImage": "https://cdn.mos.cms.futurecdn.net/5dAXgPi7G3AGuNKBauTePD-1200-80.jpg",
        "publishedAt": "2022-12-30T11:00:26Z",
        "content": "Microbes carried by laser-propelled sails could serve as interstellar probes that can build communications stations to phone home from Alpha Centauri, suggests a scientist known for wanting to resurr… [+10068 chars]"
      },
      {
        "source": {
          "id": "google-news",
          "name": "Google News"
        },
        "author": null,
        "title": "Year-Ender | NASA’s viral images that broke the internet in 2022 - The Financial Express",
        "description": null,
        "url": "https://news.google.com/__i/rss/rd/articles/CBMieWh0dHBzOi8vd3d3LmZpbmFuY2lhbGV4cHJlc3MuY29tL2xpZmVzdHlsZS9zY2llbmNlL3llYXItZW5kZXItbmFzYXMtdmlyYWwtaW1hZ2VzLXRoYXQtYnJva2UtdGhlLWludGVybmV0LWluLTIwMjIvMjkzMTk2OC_SAX5odHRwczovL3d3dy5maW5hbmNpYWxleHByZXNzLmNvbS9saWZlc3R5bGUvc2NpZW5jZS95ZWFyLWVuZGVyLW5hc2FzLXZpcmFsLWltYWdlcy10aGF0LWJyb2tlLXRoZS1pbnRlcm5ldC1pbi0yMDIyLzI5MzE5NjgvbGl0ZS8?oc=5",
        "urlToImage": null,
        "publishedAt": "2022-12-30T10:59:27Z",
        "content": null
      },
      {
        "source": {
          "id": "cbs-news",
          "name": "CBS News"
        },
        "author": "William Harwood",
        "title": "SpaceX caps '22 with record-setting 61st Falcon 9 launch - CBS News",
        "description": "The year's final SpaceX launch put an Israeli Earth-imaging satellite into orbit.",
        "url": "https://www.cbsnews.com/news/spacex-closes-out-22-with-record-setting-61st-falcon-9-launch/",
        "urlToImage": "https://assets2.cbsnewsstatic.com/hub/i/r/2022/12/30/937d9064-b0bf-418a-b34b-3a00a9ac1423/thumbnail/1200x630/71e951f85ae513b8bdee95de41ef0c5c/123022-launch.jpg",
        "publishedAt": "2022-12-30T10:36:06Z",
        "content": "Closing out a record-setting year, SpaceX launched a $186 million Israeli Earth-imaging satellite early Friday, the California rocket builder's 61st and final Falcon 9 launch of 2022 and its seventh … [+3735 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Nationworldnews.com"
        },
        "author": "https://www.facebook.com/nationworldnews1",
        "title": "Deadpool Effect? Scientists Have Created A Robot That Revives Even After Being Stabbed - Nation World News",
        "description": "any marvel fan knows that one of the powers dead pool It is a quick healing agent. It doesn't matter if it's a scratch or if your legs are cut, or even your",
        "url": "https://nationworldnews.com/deadpool-effect-scientists-have-created-a-robot-that-revives-even-after-being-stabbed/",
        "urlToImage": "https://nationworldnews.com/wp-content/uploads/2022/12/Deadpool-effect-Scientists-have-created-a-robot-that-revives-even.jpg",
        "publishedAt": "2022-12-30T10:34:25Z",
        "content": "any marvel fan knows that one of the powers dead pool It is a quick healing agent. It doesn’t matter if it’s a scratch or if your legs are cut, or even your head: everything can regenerate. But few p… [+1558 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Hindustan Times"
        },
        "author": "HT Tech",
        "title": "What is your favourite Hubble Telescope image? NASA wants to know - HT Tech",
        "description": "NASA's Hubble Space Telescope has shared a few images captured by it and the US space agency wants to know, which one is your favourite. Check images, full details here.",
        "url": "https://tech.hindustantimes.com/photos/what-is-your-favourite-hubble-telescope-image-nasa-wants-to-know-71672395489655.html",
        "urlToImage": "https://images.hindustantimes.com/tech/img/2022/12/30/1600x900/Untitled_design_-_2022-12-30T154225933_1672395676783_1672395676926_1672395676926.png",
        "publishedAt": "2022-12-30T10:27:58Z",
        "content": "Top SectionsExplore Tech Copyright © HT Media Limited All rights reserved."
      },
      {
        "source": {
          "id": null,
          "name": "India Today"
        },
        "author": "Reuters",
        "title": "Nasa mulls SpaceX backup plan for crew of Russia's leaky Soyuz ship - India Today",
        "description": "If Russia cannot launch another Soyuz ship, or decides for some reason that doing so would be too risky, Nasa is weighing another option.",
        "url": "https://www.indiatoday.in/science/story/nasa-mulls-spacex-backup-plan-for-crew-of-russias-leaky-soyuz-ship-2315463-2022-12-30",
        "urlToImage": "https://akm-img-a-in.tosshub.com/indiatoday/images/story/202212/dragon_7-sixteen_nine.jpg?VersionId=LEMG8Unr_VGgG7l6lb_sPIEF9gWEDpLH",
        "publishedAt": "2022-12-30T10:15:27Z",
        "content": "By Reuters: Nasa is exploring whether SpaceX's Crew Dragon spacecraft can potentially offer an alternative ride home for some crew members of the International Space Station after a Russian capsule s… [+5028 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "The Indian Express"
        },
        "author": "Sethu Pradeep",
        "title": "These are the missions that will go to the Moon in 2023 - The Indian Express",
        "description": "NASA's Artemis 1 mission shifted humanity's attention to the Moon in 2022. But in 2023, various Moon missions from national space agencies and private space companies are headed to Earth's lone natural satellite.",
        "url": "https://indianexpress.com/article/technology/science/moon-missions-nasa-isro-ispace-luna-25-8352516/",
        "urlToImage": "https://images.indianexpress.com/2022/12/Yusaku-Maezawa-SpaceX-20221209-2.jpg",
        "publishedAt": "2022-12-30T10:02:38Z",
        "content": "2022 marks the year when humanity again turned its attention to the Moon with NASAs Artemis 1 mission fly-by around Earths lone satellite. The Orion spacecraft concluded a 25-day mission, which saw i… [+6235 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Florida Today"
        },
        "author": ", Florida Today",
        "title": "2023 promises to be another packed year for Florida rocket launches - Florida Today",
        "description": "If this year is anything like 2022 – and it likely will be – Florida's Space Coast is in for a whopping pace of rocket launches and other activities.",
        "url": "https://www.floridatoday.com/story/tech/science/space/2022/12/30/2023-promises-to-be-packed-year-for-florida-rocket-launches/69720729007/",
        "urlToImage": "https://www.gannett-cdn.com/presto/2022/12/28/PBRE/940f5a86-7d4c-4a51-9a90-8fe7230ca2a1-SpaceX_Starlink_launch_12-28_1.JPG?auto=webp&crop=7060,3972,x0,y701&format=pjpg&width=1200",
        "publishedAt": "2022-12-30T10:01:44Z",
        "content": "Space is important to us and thats why we're working to bring you top coverage of the industry and Florida launches. Journalism like this takes time and resources. Please support it with a subscripti… [+7073 chars]"
      },
      {
        "source": {
          "id": null,
          "name": "Fatherly"
        },
        "author": "Devan McGuinness",
        "title": "The Newest JWST NASA Picture Reveals An Astounding Wreath Of Stars - Fatherly",
        "description": "Taken from the James Webb Space Telescope (JWST), the new image shows off a festive wreath that looks like a magical galaxy.",
        "url": "https://www.fatherly.com/news/nasa-jwst-wreath-of-stars",
        "urlToImage": "https://imgix.bustle.com/uploads/image/2022/12/29/e5bc7e3c-b6be-49ed-96a5-c6cde4c9b57e-52577236876_7fe171479b_k.jpg?w=1200&h=630&fit=crop&crop=faces&fm=jpg",
        "publishedAt": "2022-12-30T10:00:25Z",
        "content": "NASA has released another photo showing the absolute wonder of space. Taken from the James Webb Space Telescope (JWST), the new image shows off a festive wreath that looks like a magical star for us … [+1876 chars]"
      }
  ]